import PageHeader from "@/components/common/PageHeader";
import { FileSearch, Store, Upload } from "lucide-react";
import { Link } from "react-router-dom";

const workflows = [
  {
    to: "/tenants/onboarding",
    title: "Onboard a pharmacy",
    description:
      "Create the tenant, store, owner, plan, and safe activation defaults.",
    icon: Store,
  },
  {
    to: "/support/imports",
    title: "Import support",
    description:
      "Open a time-bound, store-scoped support session to diagnose or retry an import.",
    icon: FileSearch,
  },
] as const;

function OnboardingImportsPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Onboarding & Imports"
        subtitle="Controlled pharmacy activation and audited import support."
      />

      <div className="grid gap-4 md:grid-cols-2">
        {workflows.map((workflow) => {
          const Icon = workflow.icon;
          return (
            <Link
              key={workflow.to}
              to={workflow.to}
              className="group rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:border-slate-300 hover:shadow-md"
            >
              <div className="flex items-start gap-4">
                <span className="rounded-xl bg-slate-900 p-3 text-white">
                  <Icon className="h-5 w-5" />
                </span>
                <div>
                  <h2 className="font-semibold text-slate-900">
                    {workflow.title}
                  </h2>
                  <p className="mt-2 text-sm leading-6 text-slate-500">
                    {workflow.description}
                  </p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      <div className="rounded-2xl border border-blue-100 bg-blue-50 p-5 text-sm text-blue-900">
        <div className="flex items-start gap-3">
          <Upload className="mt-0.5 h-5 w-5" />
          <p>
            Import files remain immutable. Support access is time-bound and
            every diagnostic view or retry is written to the audit trail.
          </p>
        </div>
      </div>
    </div>
  );
}

export default OnboardingImportsPage;
